module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.f7c2cad2.ttf";